import React, { Component } from "react";
import { PacksFilterForm } from "components/filterForms";
import PacksNoResults from "views/packs/Overview/PacksNoResults";
import { type PackGridStepOwnProps } from "features/Accounts/PackAssignmentModal/types";
import { LazyCardsViewerWithHeaderAndPanel } from "components/cardsViewer";
import AddToAccountPackCard, {
  type Item,
} from "features/Accounts/PackAssignmentModal/packAssignmentSteps/packGridStep/addToAccountPackCard/AddToAccountPackCard";
import { type CardsViewerItem } from "components/cardsViewer/types";

export type PackGridStepProps = PackGridStepOwnProps;

export class PackGridStep extends Component<PackGridStepProps> {
  renderCard = (props: CardsViewerItem<Item>) => <AddToAccountPackCard {...props} />;

  // This component will be cloned and receives needed props inside FilterPanel component.
  // @ts-ignore
  renderPacksFilterForm = () => <PacksFilterForm />;

  render() {
    const {
      items,
      isLoading,
      filterOptions,
      appliedFilter,
      selectedIds,
      sortOptions,
      onSelectedItemsChanged,
      blur,
      onSortOptionsChanged,
      applyFilter,
      resetFilter,
      loadItemsToAddPage,
      itemsCount,
      renderSearch,
      isPacksModalFiltered,
      areAllLoaded,
      renderFilterForm,
      hideFilterPanel,
      createPackButton,
    } = this.props;
    return (
      <div className="assignment-grid-step">
        <LazyCardsViewerWithHeaderAndPanel
          getData={loadItemsToAddPage}
          items={items}
          itemsAmount={itemsCount}
          isLoading={isLoading}
          isAllLoaded={areAllLoaded}
          onSelectedItemsChanged={onSelectedItemsChanged}
          blur={blur}
          onSortOptionsChanged={onSortOptionsChanged}
          selectedItemIds={selectedIds}
          sortOptions={sortOptions}
          filter={appliedFilter}
          filterOptions={filterOptions}
          applyFilter={applyFilter}
          resetFilter={resetFilter}
          renderFilterForm={renderFilterForm || this.renderPacksFilterForm}
          noResultsContent={<PacksNoResults filtered={isPacksModalFiltered} createButton={createPackButton?.()} />}
          renderCard={this.renderCard}
          renderSearch={renderSearch}
          hideFilterPanel={hideFilterPanel}
        />
      </div>
    );
  }
}

export default PackGridStep;
